export default function ServicesSection() {
    const services = [
      {
        title: "Drilling Rigs & Integrated Packages",
        description: "High-performance land rigs from 1,000 to 3,000 HP — HPHT-ready, fast-moving, and optimized for deep and complex wells. Features include AC-VFD power, advanced control systems, modular substructures, and full rig-floor automation options.",
        image: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1763711383/Margin_3_stq8zb.png" 
      },
      {
        title: "Solids Control & Cuttings Management",
        description: "Shakers, centrifuges, dryers, mud cleaners, gas separators, vacuum pumps, dewatering systems, and cooling units engineered to maintain drilling fluid integrity while reducing waste, mass, and handling time.",
        image: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1763711378/Margin_1_s09uwb.png" 
      },
      {
        title: "Pumps, Mixing Systems & Surface Equipment",
        description: "Centrifugal, shear, screw, and slurry pumps; jet mixers; agitators; tank farms; MCC units; dosing skids; and power systems for high-demand drilling environments.",
        image: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1763711379/Margin_2_vpgj3b.png" 
      },
      {
        title: "Pipe Handling & Rig Floor Automation",
        description: "Power catwalks, pipe racks, stand transfer systems, iron roughnecks, drill-floor manipulators, saver subs, and integrated HMI control for safer, faster tripping operations.",
        image: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1763711383/Margin_hfgwpq.png" 
      },
      {
        title: "Engineering, Execution & Lifecycle Support",
        description: "Front-end engineering, rig-up, commissioning, brownfield upgrades, performance tuning, FAT coordination, spares, overhauls, repairs, and technical training for field teams.",
        image: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1763711375/Margin_4_f7lqli.png" 
      },
      {
        title: "Pipe, Tubular, and Line Pipe Solutions",
        description: "A full range of OCTG, SAWL, SAWH, ERW, coiled tubing, and RTP — manufactured to global standards, supported with threading, storage, running, repair, and recertification services.",
        image: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1763711383/Margin_5_vhqjoq.png" 
      }
    ];
  
    return (
      <section className="bg-white py-20 lg:py-32">
        <div className="max-w-[1160px] mx-auto px-6 sm:px-8 lg:px-12">
          {/* Section Header */}
          <div className="mb-16">
            <span className="text-[#E37D33] font-medium text-lg ">
              Our services
            </span>
            <h2 className="text-3xl sm:text-[42px] font-medium text-[#010305] mt-4 mb-6 leading-tight">
              A complete lineup of <br /> field-proven systems
            </h2>
            <p className="text-lg text-[#677078] leading-relaxed max-w-4xl">
              At Alphaden Exploration and Production, We deliver integrated oilfield solutions backed by global manufacturing 
              strength and local execution expertise. that empower growth, sustainability, and success. With a commitment to 
              excellence, safety, and environmental responsibility, our services are designed to meet the unique challenges of today's 
              dynamic landscape.
            </p>
          </div>
  
          {/* Services Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="group bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col h-full"
              >
                {/* Image Container */}
                <div className="relative h-64 bg-gray-200 overflow-hidden">
                  {service.image ? (
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200">
                      <svg 
                        className="w-20 h-20 text-gray-400"
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                      >
                        <path 
                          strokeLinecap="round" 
                          strokeLinejoin="round" 
                          strokeWidth={1.5} 
                          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" 
                        />
                      </svg>
                    </div>
                  )}
                </div>
  
                {/* Content */}
                <div className="p-8 flex flex-col flex-1">
                  <h3 className="text-xl font-semibold text-[#010305] mb-[20px]">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    {service.description}
                  </p>
                  
                  {/* Learn More Link */}
                  <button className="group/btn text-[#E37D33] hover:text-orange-600 font-semibold text-sm flex items-center gap-2 transition-colors duration-300 mt-auto">
                    Learn more
                    <svg
                      className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform duration-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 8l4 4m0 0l-4 4m4-4H3"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }